import React, { useMemo } from 'react';
import ClientInvoiceItemFields, {
    formValueToInvoiceItem,
    getDefaultFormValue,
} from '../../../../../../../shared/ClientInvoiceItems/ClientInvoiceItemFields';
import useOrganizationClientRecordInvoiceItems from '../../../../../../../../hooks/api/useOrganizationClientRecordInvoiceItems';
import { AnimateLoadedContent } from '../../../../../../../v2BaseComponents/Loader';
import { Form } from '../../../../../../../v2BaseComponents/Form';
import { getIntl } from '../../../../../../../../utils/intl';
import SideDrawerFormContainer from '../../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';

const intl = getIntl('profiles.clientInvoiceItems.update', {
    update: 'Update',
});

export type AddInvoiceItemContentOwnProps = {
    onUpdateInvoiceItem: () => void;
    onCancel: () => void;
    clientRecordId: string;
    invoiceItemId: string;
};

export type AddInvoiceItemContentProps = AddInvoiceItemContentOwnProps;

const AddInvoiceItemContent: React.FC<AddInvoiceItemContentProps> = ({
    clientRecordId,
    onUpdateInvoiceItem,
    onCancel,
    invoiceItemId,
}) => {
    const { updateInvoiceItem, isUpdatingInvoiceItem, isLoadingInvoiceItem, invoiceItem } =
        useOrganizationClientRecordInvoiceItems({
            clientRecordId,
            onUpdatedInvoiceItem: onUpdateInvoiceItem,
            invoiceItemId,
        });
    const initialValue = useMemo(() => (invoiceItem ? getDefaultFormValue(invoiceItem) : null), [invoiceItem]);

    return (
        <AnimateLoadedContent isLoading={isUpdatingInvoiceItem || !initialValue || isLoadingInvoiceItem}>
            {() => (
                <Form
                    fillContainer
                    initialValues={initialValue!}
                    onSubmit={(values) => {
                        const invoiceItem = formValueToInvoiceItem(values);
                        updateInvoiceItem({
                            invoiceItem,
                            invoiceItemId,
                        });
                    }}
                    isDisabled={isUpdatingInvoiceItem}
                    forceStackFields
                >
                    {({ isSubmitting, handleSubmit, values }) => {
                        return (
                            <SideDrawerFormContainer
                                isDisabled={isSubmitting || isUpdatingInvoiceItem}
                                onSubmit={handleSubmit}
                                onCancel={onCancel}
                                saveText={intl('update')}
                                saveIcon="CheckCircle"
                            >
                                <ClientInvoiceItemFields values={values} />
                            </SideDrawerFormContainer>
                        );
                    }}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddInvoiceItemContent);
